import * as React from 'react'

const StarIcon = (props) => {
  return (
    <svg
      width="33"
      height="31"
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.82 0.618307C16.1331 -0.134544 17.1996 -0.134543 17.5127 0.618308L21.3006 9.72535C21.4326 10.0427 21.731 10.2596 22.0737 10.2871L31.9055 11.0753C32.7183 11.1404 33.0478 12.1547 32.4286 12.6852L24.9378 19.1019C24.6767 19.3255 24.5627 19.6764 24.6425 20.0107L26.931 29.6049C27.1202 30.398 26.2574 31.0249 25.5616 30.5999L17.1442 25.4586C16.8508 25.2794 16.4819 25.2794 16.1885 25.4586L7.77112 30.5999C7.07527 31.0249 6.21246 30.398 6.40165 29.6049L8.69022 20.0107C8.76997 19.6764 8.65596 19.3255 8.39491 19.1019L0.904096 12.6852C0.284854 12.1547 0.614421 11.1404 1.42719 11.0753L11.259 10.2871C11.6016 10.2596 11.9001 10.0427 12.0321 9.72535L15.82 0.618307Z"
        fill="#FDB022"
      />
    </svg>
  )
}

export default StarIcon
